var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTodoDone = function SvgTodoDone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "\\u56FE\\u5C42 1",
    viewBox: "0 0 1024 1024"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M512 51.2C257.64 51.2 51.2 257.64 51.2 512S257.64 972.8 512 972.8 972.8 766.36 972.8 512 766.36 51.2 512 51.2ZM387.12 709.68 221.69 544.25c-17.97-17.97-17.97-47 0-64.97s47-17.97 64.97 0l133.17 132.71 317.03-317.03c17.97-17.97 47-17.97 64.97 0s17.97 47 0 64.97L452.08 709.68c-17.51 17.97-47 17.97-64.97 0Z"
  })));
};
export default SvgTodoDone;